import Vue from "vue";
import VueRouter from "vue-router";
import {KEY_LOCALSTORE} from "../utils/constants"
//import SecureLS from "secure-ls";
//const ls = new SecureLS({ isCompression: false });

import store from "../store"


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
    meta: { requieresAuth: true },
    children: [
      {
        path: "",
        name: "ApplyForm",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ApplyForm.vue"),
        meta: {roles:["Solicitante"]}
      },
      {
        path: "solicitudes",
        name: "listcv",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Listcv.vue"),
          meta: {roles: ["SuperAdmin", "Admin"]}
      },
      {
        path: "vacante",
        name: "vacant",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Vacant.vue"),
          meta: {roles:["SuperAdmin", "Admin"]}
      },
      {
        path: "usuario",
        name: "user",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/User.vue"),
          meta: {roles:["SuperAdmin"]}
      },
      {
        path: "credenciales",
        name: "password",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ChangePassword"),
          meta: {roles:["SuperAdmin", "Admin", "Solicitante"]}
      },
    ],
  },
  {
    path: "/registro",
    name: "Registro",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Registro.vue"),
      meta: {
        guest: true,
      },
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
      meta: {
        guest: true,
      },
  },
  {
    path: "*",
    redirect: "/error-404",
  },
  {
    path: "/error-404",
    name: "NoFound",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NoFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requieresAuth)){
    if(to.meta.roles.includes(store.state.login.roles[0])){
      next()
    }else{
      next("/login")
    }
  }else{
    if(to.matched.some((record) => record.meta.guest)){
      if(store.state.login.token == null  || store.state.login.token == "" ){
        next()
      }else{
        if(store.state.login.roles?.includes("SuperAdmin") || 
          store.state.login.roles?.includes("Admin") ){
          next("/solicitudes")
        }else{
          next("/")
        }

      }
    }
   next()
  }
});
export default router;
